/**
 * Get all currently active dropdown filters
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {HTMLElement} parent
 * @returns string|false|null
 */
export function getDropdownFilters(parent) {
    const dropdownFilters = parent.querySelectorAll('[data-ct-filter="dropdown"]');

    if (dropdownFilters) {
        const filters = {};

        // Loop over all dropdownFilters withing the parent
        dropdownFilters.forEach((filter) => {
            if (!filter.checked) {
                // Nothing to do if the filter is not checked
                return;
            }

            // Get taxonomy and the term this current filter applies to
            const taxonomy = filter.name;
            const term = filter.value;

            // We want to build an object containing all terms to filter for under a key that specifies the taxonomy
            // const filters = {
            //     taxonomy1: ['term1', 'term2'],
            //     taxonomy2: ['term1', 'term2'],
            // };
            filters[taxonomy] = filters[taxonomy] || []; // This makes sure the array for this key already exists. If not it creates an empty array (necessary to make the next step work).
            filters[taxonomy] = filters[taxonomy].concat(term); // Use Array.concat to add the term to the filters array.
        });

        // Now we create a query string out of the given filters object
        const paramString = new URLSearchParams(filters).toString();

        if (paramString !== '') {
            return paramString;
        }
    }

    return false;
}
